import { Resource } from "../resource";


export class GlobalAttribute extends Resource {
    uid: string;
    value: string;
}